import React from 'react';

export default function ClaimsPage() {
    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white font-weight-bold">Lodgment of Claims</h2>
                    </div>
                </div>
                <div className="row content">
                    <div className="col-1"></div>
                    <div className="col-10 shadow bg-white rounded p-5">
                        <p>
                            As your insurance broker, we continuously work to protect the best interests of our customers. 
                            If you have any issues with the use of instaPol or your claim, we are here to help. You may contact us in as many convenience ways as possible.
                        </p>
                        <p className="font-weight-bold">Contact Us</p>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="font-weight-bold">Customer Service Careline</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="tel:+60122606183">+60122606183</a>
                                <p>Operating Hours: Monday to Friday (8:45 am to 5:45 pm)</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="font-weight-bold">WhatsApp No.</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a target="_blank" href={"https://api.whatsapp.com/send?phone=60122606183&text=" + process.env.MIX_APP_NAME}>+60122606183</a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="font-weight-bold">WhatsApp Link</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a target="_blank" href={"https://api.whatsapp.com/send?phone=60122606183&text=" + process.env.MIX_APP_NAME}>www.instapol.cs/whatsapp</a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="font-weight-bold">or Scan QR Code to WhatsApp</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <img src="../images/whatsapp-qr1.png" alt="WhatsApp" width="120"></img>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="font-weight-bold">Email Us at</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="mailto:insta.admin@my.howdengroup.com">insta.admin@howdengroup.com</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
        </section>
    );
}